module.exports = __webpack_public_path__ + "static/media/Inter-SemiBold.67b2d54e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Inter/Inter-SemiBold.ttf
// module id = 362
// module chunks = 17